angular.module('files')
    .service('FilesLibrary', function ($rootScope, modals, $filter, toastr, FileAssociation) {
        this.open = () => modals.open('app/files/file-bind-library-modal.html', 'filesLibraryCtrl', {}, {size: 'lg'});
        this.openAndBind = resource => {
            return this.open().then(selectedFiles => {
                let file_ids = selectedFiles.map(file => file.id);
                let params = {};
                params.type = $filter('lowercase')(resource.type);
                params.id = resource.id;

                return FileAssociation.save(params, file_ids, result => {
                    toastr.success("Powiązano " + result.length + " plików");
                    $rootScope.$broadcast("file.saved", result);
                }, err => toastr.error("Błąd zapisu! " + err.status)).$promise;
            });
        };
    })
    .controller('filesLibraryCtrl', function ($scope, $uibModalInstance, Folder, File, toastr, FileUploadFoldersService, FileService, FolderService) {
        $scope.FileUploadFoldersService = FileUploadFoldersService
        $scope.FileService = FileService;

        $scope.folderTree = {};
        $scope.filters = {};
        $scope.selected = [];
        $scope.folders = [{id: null, name: ".."}];
        Folder.query(folders => {
            $scope.folders = $scope.folders.concat(folders);
            FolderService.formatFolders($scope.folders);
        });

        $scope.refreshFiles = () => File.notArchived($scope.filters).$promise.then(response => $scope.page = response);
        $scope.refreshFiles();

        $scope.onFolderSelect = folder => {
            $scope.filters.folder = folder.id;
            $scope.filters.page = null;
            $scope.refreshFiles();
        };

        $scope.$on('file.saved', () => $scope.refreshFiles());

        $scope.pick = item => {
            if ($scope.selected.indexOf(item) === -1) {
                $scope.selected.push(item);
            } else {
                //toastr.error("Plik "+item.filename+" został już wybrany", "Błąd!");
            }
        };

        $scope.unpick = $index => $scope.selected.splice($index, 1);
        $scope.search = () => $scope.refreshFiles();
        $scope.reset = () => {
            $scope.filters = {};
            $scope.folderTree.select_branch(null);
            $scope.search();
        };

        $scope.close = () => {
            $uibModalInstance.dismiss();
            $scope.$destroy();
        };

        $scope.submit = () => $uibModalInstance.close($scope.selected);

        $scope.pageChanged = () => {
            $scope.filters.page = $scope.page.pageNumber;
            $scope.refreshFiles();
        };
    });
